module.exports = __webpack_public_path__ + "static/media/ic_XLS.6c599f52.svg";